<template>
  <div class="login">
      <form autocomplete="off" @submit.prevent="login" method="post">
        <div class="login-form">
          <h2>Login</h2>
          <div class="alert alert-danger" v-if="error">
              <p>Invalid email and/or password.<br />Please try again.</p>
          </div>
          <div class="form-row">
            <div class="form-input">
              <label for="email">E-mail</label>
              <input type="email" id="email" class="form-control" v-model="email" required>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input">
              <label for="password">Password</label>
              <input type="password" id="password" class="form-control" v-model="password" required>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input">
              <button class="red-button btn btn-default" id="login" type="submit">Sign in</button>
            </div>
          </div>
        </div>
      </form>
  </div>
</template>

<script>
import router from '../router';

export default {
  name: 'Login',
  components: {
  },
  data() {
    return {
      email: '',
      password: '',
      error: false,
    };
  },
  methods: {
    login() {
      const app = this;
      this.error = false;
      this.$auth
        .login({
          data: { email: this.email, password: this.password },
          rememberMe: true,
          redirect: '/samples',
        })
        .then(() => {
          console.log('success');
          // router.push('samples');
        }, () => {
          app.error = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';

  .login-form{
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
  }

  .form-row{
    display: flex;
    flex-direction: row;
    .form-input{
      flex: 1;
      padding-left: 1rem;
      padding-right: 1rem;
      margin-bottom: 1rem;

      label{
        display: block;
        font-weight: 300;
        text-transform: uppercase;
        margin-bottom: 5px;

      }
      select, input{
        width: 100%;
        height: 40px;
        line-height: 40px;
        -webkit-border-radius: 0px;
        background-color: $white;
        padding: 0 1rem;
      }

    }
    &.reverse{
      flex-direction: row-reverse;
      margin-right: 1rem;
      margin-left: 1rem;
    }
    @media screen and (max-width: $break-medium) {
      flex-direction: column;
    }
  }

  .red-button{
    background-color: $red;
    color: $white;
    height: 50px;
    padding-left: 3rem;
    padding-right: 3rem;
    text-transform: uppercase;
    border: none;
    cursor: pointer;
    &:hover{
      background-color: $dark-red;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/Login.vue